<template>
  <div
    class="fixed top-0 bottom-0 left-0 right-0 p-6 z-50 flex items-center justify-center cursor-default
  bg-gray-100-25"
  >
    <div
      class="px-6 pb-6 max-h-full w-full overflow-y-scroll max-w-sm bg-white shadow-lg rounded last:mb-0"
    >
      <div class="flex justify-between pb-4 pt-6 sticky top-0 bg-white">
        <h2 class="mb-0" :class="headerClass">
          {{ header }}
        </h2>
        <ion-icon
          name="close-outline"
          class="fs-2 ml-2 cursor-pointer flex-shrink-0"
          @click.prevent="closeModal"
        />
      </div>

      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    header: String,
    headerClass: String,
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
